import React, { useState } from "react";

const InviteMembers = () => {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleSendInvitation = async () => {
    if (!email) {
      alert("Please enter an email address.");
      return;
    }

    console.log("Sending invitation to:", email);

    try {
      const response = await fetch("http://localhost:5100/api/invite", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      console.log("Response status:", response.status);

      const data = await response.json();

      if (!response.ok) {
        console.error("Server error:", data);
        throw new Error(data.message || "Something went wrong");
      }

      console.log("Invitation sent successfully:", data);
      setSuccessMessage(`Invitation sent to ${email}!`);
      setEmail(""); // Réinitialiser le champ
    } catch (error) {
      console.error("Error sending invitation:", error.message);
      setErrorMessage(error.message || "An error occurred.");
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-50">
      <div className="w-full max-w-md bg-white p-8 rounded-lg shadow-md">
        <h2 className="text-2xl font-bold text-center text-blue-600 mb-6">
          Invite Members
        </h2>

        {errorMessage && (
          <p className="text-red-500 text-center mb-4">{errorMessage}</p>
        )}
        {successMessage && (
          <p className="text-green-500 text-center mb-4">{successMessage}</p>
        )}

        <div className="mb-6">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
            placeholder="Enter email address"
          />
        </div>

        <button
          onClick={handleSendInvitation}
          className="w-full bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition duration-300"
        >
          Send Invitation
        </button>
      </div>
    </div>
  );
};

export default InviteMembers;